<template>
  <div class="banner-wrapper">
    <ul class="banner-content">
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-01.png" alt="" srcset="" />
        <h3 class="title">银行存管</h3>
        <p>资金操作由银行验证</p>
      </li>
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-02.png" alt="" srcset="" />
        <h3 class="title">多种服务</h3>
        <p>多种优质的金融服务</p>
      </li>
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-03.png" alt="" srcset="" />
        <h3 class="title">电子安全保障</h3>
        <p>保障合同法律效力</p>
      </li>
      <li class="banner-item">
        <img src="https://files.jinr.com/jinr-index/img/banner-icon-04.png" alt="" srcset="" />
        <h3 class="title">信息透明</h3>
        <p>运营数据及时披露</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'banner'
};
</script>
<style lang="less" scoped>
.banner-wrapper {
  background: #fff;
  height: 6.8rem;
  .banner-content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: center;
    .banner-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      width: 50%;
      // height: 2.78rem;
      padding: 0.32rem 0;
      img {
        height: 1.39rem;
      }
      h3 {
        font-family: 'PingFangSC-Medium';
        font-size: 0.3rem;
        color: #2c6eff;
        line-height: 1;
        margin: 0.27rem 0 0.21rem;
      }
      p {
        font-family: 'PingFangSC-Regular';
        font-size: 0.26rem;
        color: #666666;
        text-align: center;
        line-height: 1;
      }
    }
  }
}
</style>
